import { HelpItem } from "./HelpItem";

// 使用单例模式缓存扁平化结果
export class HelpItemManager {
    private static instance: HelpItemManager;
    private flattenedItems: HelpItem[] = [];

    private constructor() {}

    static getInstance(): HelpItemManager {
        if (!HelpItemManager.instance) {
            HelpItemManager.instance = new HelpItemManager();
        }
        return HelpItemManager.instance;
    }

    // 只执行一次的扁平化函数
    initializeFlattenedItems(items: HelpItem[]): void {
        this.flattenedItems = this.flattenItems(items);
    }

    private flattenItems(items: HelpItem[]): HelpItem[] {
        return items.reduce((acc, item) => {
            acc.push(item);
            if (item.children && item.children.length) {
                acc.push(...this.flattenItems(item.children));
            }
            return acc;
        }, [] as HelpItem[]);
    }

    // 异步搜索函数
    async searchHelpItems(searchTerm: string, maxResult: number): Promise<HelpItem[]> {
        return new Promise((resolve) => {
            try 
            {
                const searchRegex = new RegExp(searchTerm, 'i');
                const results = this.flattenedItems
                    .filter(item => searchRegex.test(item.title))
                    .slice(0, maxResult);
                
                resolve(results);
            }catch(error) {
                console.error('Error searching help items:', error);
                resolve([]);
            }
        });
    }
}